import React, { useCallback, useMemo, useState } from 'react';
import Visibility from '../../components/Visibility';
import { Title } from '../../components/layouts';
import './style.scss';
import { getTrack, pureTrans } from '../../helpers';

export function SmartShotIntro({ mobile = false }) {
  const [progress, setProgress] = useState(0);
  const { a1, a2, a3 } = useMemo(() => {
    const os1 = mobile ? [-2, -1] : [-1, -0.2, 0.4];
    const os2 = mobile ? [-0.5, 0.5] : [0, 0.2, 0.4];
    const ot = mobile ? [0, 1] : [0, 0.8, 1];
    return {
      a1: pureTrans(progress, os1, ot, 3),
      a2: pureTrans(progress, os2, ot, 3),
      a3: pureTrans(progress, [-1, -0.2, 0.5, 1], [-10, -30, 10, 40], 3)
      // a3: pureTrans(progress, [-1, -0.2, 0.5, 1], [0, 10, 20, 40], 3)
    };
  }, [progress, mobile]);

  const handleUpdate = useCallback(
    (e, { calculations: { topPassed, percentagePassed, bottomPassed, ...rest } }) => {
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-12 inverted">
      {/*<div className="section-content title center" style={{ transform: `translateY(${a3}%) translateZ(0)` }}>*/}
      {/*  <Title>*/}
      {/*    <span style={{ opacity: a1 }}>全场景</span>*/}
      {/*    /!*{mobile && <br />}*!/*/}
      {/*    <span style={{ opacity: a2 }}>智慧影像</span>*/}
      {/*  </Title>*/}
      {/*</div>*/}
      <div className="section-content title center">
        <Title>
          <span>全场景</span>
          {/*{mobile && <br />}*/}
          <span>智慧影像</span>
        </Title>
      </div>
    </Visibility>
  );
}
